<template>
  <v-btn @click="onClick" x-small>Send Invite</v-btn>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'InviteButton',
  
  props: ['pro'],

  methods: {
    ...mapActions('pros', ['reinvite']),

    onClick() {
      let { pro_id } = this.pro
      this.reinvite({ pro_id })
    }
  }
}
</script>